exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-enter[data-v-55bdb64c],.v-leave-to[data-v-55bdb64c]{opacity:0}.v-enter-active[data-v-55bdb64c],.v-leave-active[data-v-55bdb64c]{transition:opacity .5s}", ""]);

// exports
